import Room from "./Room";
function App() {
  return (
    <div>
      <Room />
    </div>
  );
}

export default App;
